import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { CareerApiResponse } from '../models/career.interface';

@Injectable({
    providedIn: 'root'
})
export class CommonApiService {
    constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: object) {}

    getCareerPosts(): Observable<CareerApiResponse> {
        return this.post('posts/career', {}) as Observable<CareerApiResponse>;
    }

    getCareerList(): Observable<any> {
        return this.post('get-categories', { template: 'careers-details' });
    }

    getPageData(slug: string): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return throwError(() => new Error('SSR'));
        return this.post('get-page', { slug });
    }

    submitForm(payload: { form_id: string; fields: { [key: string]: string }; form_listing_id?: string; utm?: Record<string, string> }): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return throwError(() => new Error('SSR'));
        return this.post('form-submit', payload);
    }

    sendOtp(email: string, phone: string, countryCode: string = '+91', formListingId?: string): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return throwError(() => new Error('SSR'));
        return this.post('otp/services', {
            actionType: 'sendOtp',
            data: { mobile_number: phone, country_code: countryCode, email, form_listing_id: formListingId }
        });
    }

    resendOtp(email: string, phone: string, countryCode: string = '+91', formListingId?: string): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return throwError(() => new Error('SSR'));
        return this.post('otp/services', {
            actionType: 'resendOtp',
            data: { mobile_number: phone, country_code: countryCode, email, form_listing_id: formListingId }
        });
    }

    verifyOtp(email: string, phone: string, otp: string, countryCode: string = '+91'): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return throwError(() => new Error('SSR'));
        return this.post('otp/services', {
            actionType: 'verifyOtp',
            data: { mobile_number: phone, country_code: countryCode, email, otp }
        });
    }

    generateFormCaptcha(formId: string): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return throwError(() => new Error('SSR'));
        return this.post('captcha/generate-captcha', { form_id: formId });
    }

    verifyFormCaptcha(formId: string, token: string, captcha: string): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return throwError(() => new Error('SSR'));
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const xRandomToken = Array.from({ length: 16 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
        return this.postWithHeaders('captcha/verify-captcha', { form_id: formId, token, captcha }, { 'x-auth-token': xRandomToken }).pipe(
            map(response => ({ ...response, _xRandomToken: btoa(xRandomToken) }))
        );
    }

    private post(endpoint: string, body: any): Observable<any> {
        return this.http.post<any>('/api/kalamlite/' + endpoint, body, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        }).pipe(catchError(this.handleError));
    }

    private postWithHeaders(endpoint: string, body: any, extraHeaders: { [key: string]: string }): Observable<any> {
        return this.http.post<any>('/api/kalamlite/' + endpoint, body, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', ...extraHeaders })
        }).pipe(catchError(this.handleError));
    }

    private handleError(error: any): Observable<never> {
        console.error('API Error:', error);
        throw error;
    }
}
